import React from "react"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { data } from "../../../../data/nsf"

const NSFBadge = () => {
  const { badge } = data
  const { heading, image } = badge

  return (
    <section className="">
      <div className={`flex gap-4  items-center justify-center`}>
        <div className={``}>
          <img
            src={image}
            alt={``}
            role={`presentation`}
            className="max-w-[135px]"
          />
        </div>
        <div>
          <TextElementNova
            element={`p`}
            className="Caption-10-Dia-Uppercase text-left sm:text-center nfs-heading"
            text={heading}
          />
        </div>
      </div>
    </section>
  )
}

export default NSFBadge
